import React from 'react';
import { Shield, Award, Clock } from 'lucide-react';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-24 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-slate-50"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold">
                Experts en travaux d'accès difficile
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              Votre sécurité,
              <span className="text-blue-700"> notre priorité</span>
            </h1>
            
            <p className="text-xl text-slate-600 leading-relaxed">
              Spécialistes des travaux en hauteur et d'accès difficile sur la Côte d'Azur. 
              Intervention rapide et professionnelle pour tous vos projets de façade, toiture et sécurisation.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-blue-700 text-white px-8 py-4 rounded-lg hover:bg-blue-800 transition-all font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Demander un devis gratuit
              </button>
              <button 
                onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-slate-300 text-slate-700 px-8 py-4 rounded-lg hover:border-blue-700 hover:text-blue-700 transition-all font-semibold text-lg"
              >
                Nos services
              </button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-6">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Shield className="text-blue-700" size={32} />
                </div>
                <p className="text-sm font-semibold text-slate-900">Sécurité maximale</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Award className="text-blue-700" size={32} />
                </div>
                <p className="text-sm font-semibold text-slate-900">Certifiés IRATA</p>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Clock className="text-blue-700" size={32} />
                </div>
                <p className="text-sm font-semibold text-slate-900">Intervention rapide</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1674558346850-7cbd4025ecff" 
                alt="Professionnel Riviera Rope Access" 
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl">
              <p className="text-3xl font-bold text-blue-700">10+</p>
              <p className="text-sm text-slate-600 font-medium">Années d'expérience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;